import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-main',
  templateUrl: './faq-main.component.html',
  styleUrls: ['./faq-main.component.scss']
})
export class FaqMainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
